export default "__VITE_ASSET__CBexD6iR__"